export default "__VITE_ASSET__B1tmjoC7__"